export default __webpack_public_path__ + "static/media/payroll_home.4e310881.png";